<div class="card" *transloco="let t">
    <div class="card-body px-2" *ngIf="okService">



        <div class="row">
            <div class="col-12">
              
                            <!-- Header -->
              <div class="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h4 class="mb-1">Safety Links Management</h4>
                  <p class="mb-0">Organize and manage collections of safety links for your applications</p>
                </div>
                <div>
                  <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/articles/36454751296657-Useful-App-Links-Quick-Access-to-Forms-and-Resources" role="button" target="_new"><i class="fa-regular fa-circle-question"></i> {{ t('Help') }}</a>
                </div>
              </div>
          
                <!-- Main Content -->
                
                <!-- Header & Controls -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex align-items-center gap-3">
                    <div class="input-group" style="width: 300px;">
                      <span class="input-group-text"><i class="fa-solid fa-search"></i></span>
                      <input 
                        type="text" 
                        class="form-control" 
                        placeholder="Search sections and links..."
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="onSearchChange()">
                    </div>
                    <select 
                      class="form-select" 
                      style="width: auto;"
                      [(ngModel)]="sortOrder"
                      (ngModelChange)="onSortChange()">
                      <option value="newest">Newest First</option>
                      <option value="oldest">Oldest First</option>
                      <option value="title">By Title</option>
                    </select>
                  </div>
                  <button 
                    type="button" 
                    class="btn btn-info text-white"
                    (click)="openSectionModal()">
                    <i class="fa-solid fa-plus me-2"></i> Add Section
                  </button>
                </div>
        
                <!-- Sections and Links -->
                <div *ngIf="sectionsLoading || linksLoading" class="text-center p-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="text-muted mt-2">Loading sections and links...</p>
                </div>
                
                <div *ngIf="!sectionsLoading && !linksLoading && sections.length === 0" class="text-center p-5">
                  <i class="fa-solid fa-folder display-1 text-muted mb-3"></i>
                  <h5 class="text-muted">No sections found</h5>
                  <p class="text-muted">Create your first section to start organizing links</p>
                  <button 
                    type="button" 
                    class="btn btn-info text-whitey"
                    (click)="openSectionModal()">
                    <i class="fa-solid fa-plus me-2"></i> Create First Section
                  </button>
                </div>

                <!-- Sections with nested links -->
                <div *ngIf="!sectionsLoading && !linksLoading && sections.length > 0" 
                     class="accordion" id="sectionsAccordion">
                  
                  <div *ngFor="let section of sections; let i = index" class="accordion-item mb-3">
                    <!-- Section Header -->
                    <h2 class="accordion-header">
                      <div class="d-flex align-items-center p-3 border-bottom bg-light">
                        <div class="flex-grow-1 d-flex align-items-center">
                          <i class="fa-solid fa-folder text-primary me-3"></i>
                          <div>
                            <h5 class="mb-0">{{ section.title }}</h5>
                          </div>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <button 
                            type="button" 
                            class="btn btn-sm btn-success text-white"
                            (click)="openLinkModal(null, section.section_id)"
                            title="Add Link to Section">
                            <i class="fa-solid fa-plus me-1"></i> Add Link
                          </button>
                          <button 
                            type="button" 
                            class="btn btn-sm btn-outline-secondary"
                            (click)="openSectionModal(section)"
                            title="Edit Section">
                            <i class="fa-solid fa-pencil"></i>
                          </button>
                          <button 
                            type="button" 
                            class="btn btn-sm btn-outline-danger"
                            (click)="deleteSection(section)"
                            title="Delete Section">
                            <i class="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </h2>
                    
                    <!-- Links in this section -->
                    <div class="accordion-body p-0">
                      <div *ngIf="getLinksForSection(section.section_id).length === 0" 
                           class="text-center p-4 text-muted">
                        <i class="fa-solid fa-link-slash mb-2"></i>
                        <p class="mb-2">No links in this section yet</p>
                        <button 
                          type="button" 
                          class="btn btn-sm btn-outline-primary"
                          (click)="openLinkModal(null, section.section_id)">
                          <i class="fa-solid fa-plus me-1"></i> Add First Link
                        </button>
                      </div>
                      
                      <div *ngIf="getLinksForSection(section.section_id).length > 0" class="table-responsive">
                        <table class="table table-hover mb-0">
                          <thead class="table-light">
                            <tr>
                              <th>Link Name</th>
                              <th>URL</th>
                              <th class="text-end"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let link of getLinksForSection(section.section_id)">
                              <td>
                                <div class="d-flex align-items-center">
                                  <strong>{{ link.name }}</strong>
                                </div>
                              </td>
                              <td>
                                <a [href]="link.url" 
                                   target="_blank" 
                                   class="text-decoration-none d-flex align-items-center">
                                  <span class="text-truncate" style="max-width: 300px;">{{ link.url }}</span>
                                </a>
                              </td>
                              <td class="text-end">
                                <div class="btn-group btn-group-sm">
                                  <button 
                                    type="button" 
                                    class="btn btn-outline-success"
                                    (click)="openExternalLink(link.url)"
                                    title="Open Link">
                                    <i class="fa-solid fa-external-link-alt"></i>
                                  </button>
                                  <button 
                                    type="button" 
                                    class="btn btn-outline-secondary"
                                    (click)="openLinkModal(link)"
                                    title="Edit Link">
                                    <i class="fa-solid fa-pencil"></i>
                                  </button>
                                  <button 
                                    type="button" 
                                    class="btn btn-outline-danger"
                                    (click)="deleteLink(link)"
                                    title="Delete Link">
                                    <i class="fa-solid fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
        

        
            </div>
          </div>
        </div>
        
        <!-- Section Modal -->
        <div class="modal fade" 
             [class.show]="showSectionModal" 
             [style.display]="showSectionModal ? 'block' : 'none'"
             tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ editingSectionId ? 'Edit Section' : 'Create New Section' }}</h4>
                <button type="button" 
                        class="btn-close" 
                        (click)="closeSectionModal()"
                        aria-label="Close"></button>
              </div>
              <form [formGroup]="sectionForm" (ngSubmit)="saveSection()">
                <div class="modal-body">
                  <div class="mb-3">
                    <label for="sectionTitle" class="form-label">Section Title *</label>
                    <input 
                      type="text" 
                      id="sectionTitle"
                      class="form-control"
                      formControlName="title"
                      placeholder="Enter section title..."
                      maxlength="255">
                    <div *ngIf="sectionForm.get('title')?.invalid && sectionForm.get('title')?.touched" 
                         class="invalid-feedback d-block">
                      <div *ngIf="sectionForm.get('title')?.errors?.['required']">
                        Section title is required
                      </div>
                      <div *ngIf="sectionForm.get('title')?.errors?.['maxlength']">
                        Section title cannot exceed 255 characters
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button 
                    type="button" 
                    class="btn btn-secondary"
                    (click)="closeSectionModal()">
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    class="btn btn-info text-white"
                    [disabled]="sectionForm.invalid">
                    <i class="fa-solid fa-check me-2"></i>{{ editingSectionId ? 'Update Section' : 'Create Section' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        
        <!-- Link Modal -->
        <div class="modal fade" 
             [class.show]="showLinkModal" 
             [style.display]="showLinkModal ? 'block' : 'none'"
             tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ editingLinkId ? 'Edit Link' : 'Create New Link' }}</h4>
                <button type="button" 
                        class="btn-close" 
                        (click)="closeLinkModal()"
                        aria-label="Close"></button>
              </div>
              <form [formGroup]="linkForm" (ngSubmit)="saveLink()">
                <div class="modal-body">
                  <div class="mb-3">
                    <label for="linkSection" class="form-label">Section *</label>
                    <select 
                      id="linkSection"
                      class="form-select"
                      formControlName="section_id">
                      <option value="">Select a section...</option>
                      <option *ngFor="let section of sections" [value]="section.section_id">
                        {{ section.title }}
                      </option>
                    </select>
                    <div *ngIf="linkForm.get('section_id')?.invalid && linkForm.get('section_id')?.touched" 
                         class="invalid-feedback d-block">
                      <div *ngIf="linkForm.get('section_id')?.errors?.['required']">
                        Please select a section
                      </div>
                    </div>
                  </div>
                  
                  <div class="mb-3">
                    <label for="linkName" class="form-label">Link Name *</label>
                    <input 
                      type="text" 
                      id="linkName"
                      class="form-control"
                      formControlName="name"
                      placeholder="Enter link name..."
                      maxlength="255">
                    <div *ngIf="linkForm.get('name')?.invalid && linkForm.get('name')?.touched" 
                         class="invalid-feedback d-block">
                      <div *ngIf="linkForm.get('name')?.errors?.['required']">
                        Link name is required
                      </div>
                      <div *ngIf="linkForm.get('name')?.errors?.['maxlength']">
                        Link name cannot exceed 255 characters
                      </div>
                    </div>
                  </div>
                  
                  <div class="mb-3">
                    <label for="linkUrl" class="form-label">URL *</label>
                    <input 
                      type="url" 
                      id="linkUrl"
                      class="form-control"
                      formControlName="url"
                      placeholder="https://example.com"
                      maxlength="2048">
                    <div *ngIf="linkForm.get('url')?.invalid && linkForm.get('url')?.touched" 
                         class="invalid-feedback d-block">
                      <div *ngIf="linkForm.get('url')?.errors?.['required']">
                        URL is required
                      </div>
                      <div *ngIf="linkForm.get('url')?.errors?.['pattern']">
                        Please enter a valid URL starting with http:// or https://
                      </div>
                      <div *ngIf="linkForm.get('url')?.errors?.['maxlength']">
                        URL cannot exceed 2048 characters
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button 
                    type="button" 
                    class="btn btn-secondary"
                    (click)="closeLinkModal()">
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    class="btn btn-info text-white"
                    [disabled]="linkForm.invalid">
                    <i class="fa-solid fa-check me-2"></i>{{ editingLinkId ? 'Update Link' : 'Create Link' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        
            

    </div>
</div>

<!-- Modal backdrop -->
<div class="modal-backdrop fade show" 
     *ngIf="showSectionModal || showLinkModal"
     (click)="showSectionModal ? closeSectionModal() : closeLinkModal()"></div>
